import { PRODUCT_IMAGES } from '../../media_plan_details/media_plan_body/media_plan_config/services';

export const getImageByName = (name?: string) => {
  if (!name) return PRODUCT_IMAGES[0];
  const firstLetter = name.charAt(0).toUpperCase();
  const charCode = firstLetter.charCodeAt(0) - 65;
  const imageIndex = Math.floor(charCode / 5);
  return PRODUCT_IMAGES[imageIndex];
};
